<template>
    <div class="file-icon mr-2">
        <div class="icon-container">
            <font-awesome-icon :icon="fileIcon" fixed-width class="icon-element" />
        </div>
    </div>
</template>
<script>
import { GC_Files } from '../../config/global'

export default {
    props: {
        fileType: String
    },
    computed: {
        fileIcon() {
            return GC_Files.fileIcon(this.fileType)
        }
    }
}
</script>
<style scoped lang="scss">
@import '../../styles/bootstrap/_custom';

.file-icon {
    font-size: 2.5em;
}
.file-icon .icon-container {
    height: 1em;
    width: 1em;
    background: $primary;
    position:relative;
    border-radius: 50%;
}
.file-icon .icon-container .icon-element {
    font-size: 0.5em;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/file-elements/file-icon.vue